export const Sentry = {
  key: process.env.REACT_APP_SENTRY_KEY,
  project: process.env.REACT_APP_SENTRY_PROJECT
};
